
export const INVOICE_LIST_ID = 'invoicesList';
